import CountryItem from '../models/CountryIDDataLayer';
import CartType from '../models/CartType';

const initialize = sessionData => {
  let divisionId = '246579';
  let countryId = '687PDC';
  let productSeriesName =
    'Hydrostatic Pumps & Motors for Open and Closed Circuits - Gold Cup Series';
  let language = 'EN';
  let isProduction = false;
  let applicationName = 'PARKER E-CONFIGURATOR';
  let pageId;

  divisionId = sessionData.manufacturingDivision;
  countryId = sessionData.countryId;
  productSeriesName = sessionData.seriesName;
  language = sessionData.language;

  let navOwner = countryId;
  let contentOwner = divisionId;
  pageId = contentOwner + ' - ' + productSeriesName + ' - ' + applicationName; // must be unique for all of Parker's millions of web pages
  let categoryId = navOwner + ':' + applicationName;
  let attribute1 =
    navOwner + '-_-' + contentOwner + '-_-' + navOwner + '-_-' + language;
  let countrycheck = CountryItem;
  let countryID = countrycheck.CountryList.filter(
    x => x.CountryID.toLowerCase() == sessionData.countryId.toLowerCase()
  )[0].LangID;

  // Retrieve the previous URL from the cookie (if available)
  var previousURL = getCookie('previousURL');

  // Set the current page's URL as the new previous URL in the cookie
  document.cookie =
    'previousURL=' +
    encodeURIComponent(window.location.href) +
    ';domain=parker.com;path=/';
  if (
    previousURL !== null &&
    window.location.href !== decodeURIComponent(previousURL)
  )
    document.cookie =
      'previousURL1=' + previousURL + ';domain=parker.com;path=/';

  var previousURL1 = getCookie('previousURL1');

  console.log(decodeURIComponent(previousURL));
  console.log(decodeURIComponent(previousURL1));

  window['dataLayer'].push({
    event: 'page_view',
    page_name:
      sessionData.manufacturingDivision +
      ' - ' +
      sessionData.seriesName +
      ' - ' +
      applicationName,
    page_referrer:
      previousURL1 == null ? 'N/A' : decodeURIComponent(previousURL1),
    content_group: 'configurator',
    country: countryID.toUpperCase(),
    language: sessionData.language.toUpperCase(),
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: 'N/A',
    product_series_name: sessionData.seriesName,
    product_id: 'N/A',
    part_name: 'N/A',
    part_number: 'N/A',
    hit_timestamp: new Date().toISOString(),
    is_category_page: 'No',
    is_series_page: 'No',
    is_pdp: 'No',
    event_timestamp_unix: new Date().toISOString(),
    is_req_quote:
      sessionData.contentSyndication == null
        ? sessionData.cartType == CartType.Quote
          ? 'Yes'
          : 'No'
        : sessionData.contentSyndication.requestquote.visible == true
        ? 'Yes'
        : 'No',
    is_wtb:
      sessionData.contentSyndication == null
        ? sessionData.phConnect == null
          ? 'Yes'
          : sessionData.phConnect.WhereToBuy == true
          ? 'Yes'
          : 'No'
        : sessionData.contentSyndication.wheretobuy_visible == true
        ? 'Yes'
        : 'No',
    is_buyable_online:
      sessionData.contentSyndication == null
        ? sessionData.cartType == CartType.Shop || sessionData.option == '100'
          ? 'Yes'
          : 'No'
        : sessionData.contentSyndication.addtocart_visible == true
        ? 'Yes'
        : 'No',
    is_configurable: 'N/A',
    product_series_id: sessionData.productId,
    mpc: sessionData.mpc == null ? 'N/A' : sessionData.mpc
  });
};

const getCookie = name => {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].split('=');
    if (cookie[0].trim() === name) {
      return cookie[1];
    }
  }
  return null;
};

const addToCartDataLayer = (sessionData, totalPrice, items) => {
  let countrycheck = CountryItem;
  window['dataLayer'].push({
    ecommerce: null
  });
  window['dataLayer'].push({
    event: 'add_to_cart',
    ecommerce: {
      currency: sessionData.currCode,
      value: Number(totalPrice.replace(/,/g, '')),
      //   'quantity': totalQuantity,
      nav_owner: sessionData.countryId,
      store_name:
        'Parker' +
        countrycheck.CountryList.filter(
          x => x.CountryID.toLowerCase() == sessionData.countryId.toLowerCase()
        )[0].LangID.toUpperCase(),
      items: items
    }
  });
};

const shareConfigurationDataLayer = (sessionData, partNumber) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'share',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber
  });
};

const partSearchDataLayer = (sessionData, partNumber) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'search',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber
  });
};

const copyToClipboardDataLayer = (sessionData, partNumber) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'copy to clipboard',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber
  });
};

const saveConfigurationDataLayer = (sessionData, partNumber, title) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'save',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber,
    configuration_name: title
  });
};

const loadConfigurationDataLayer = (sessionData, partNumber, title) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'retrieve-load',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber,
    configuration_name: title
  });
};

const deleteConfigurationDataLayer = (sessionData, partNumber, title) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'retrieve-delete',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber,
    configuration_name: title
  });
};

const cancelConfigurationDataLayer = (sessionData, partNumber, title) => {
  window['dataLayer'].push({
    event: 'econfigurator_utilities',
    cta_text: 'retrieve-cancel',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_category_name: sessionData.breadCrumbText2,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber,
    configuration_name: title
  });
};

const whereToBuyDataLayer = (sessionData, partNumber) => {
  window['dataLayer'].push({
    event: 'where_to_buy',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber
  });
};

const requestQuoteDataLayer = (sessionData, partNumber, quantity) => {
  let countrycheck = CountryItem;
  window['dataLayer'].push({
    ecommerce: null
  });
  window['dataLayer'].push({
    event: 'request_quote',
    ecommerce: {
      currency: 'USD',
      value: 0,
      nav_owner: sessionData.countryId,
      store_name:
        'Parker' +
        countrycheck.CountryList.filter(
          x => x.CountryID.toLowerCase() == sessionData.countryId.toLowerCase()
        )[0].LangID.toUpperCase(),
      items: [
        {
          item_name: partNumber + ' - ' + sessionData.seriesName,
          item_id: sessionData.productId,
          affiliation: 'N/A',
          quantity: quantity,
          price: 0,
          item_category: sessionData.breadCrumbText1,
          item_category2: sessionData.breadCrumbText2,
          item_category3: 'N/A',
          item_category4: 'N/A',
          item_category5: 'N/A',
          item_brand: 'Parker',
          item_variant: partNumber,
          coupon: 'N/A',
          discount: 'N/A',
          content_owner: sessionData.manufacturingDivision
        }
      ]
    }
  });
};

const viewSummarySheetDataLayer = (sessionData, partNumber) => {
  window['dataLayer'].push({
    event: 'view_summary_sheet',
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumber + ' - ' + sessionData.seriesName,
    part_number: partNumber,
    configuration_code: partNumber
  });
};

const supportDocumentDataLayer = (documentInfo, sessionData) => {
  window['dataLayer'].push({
    event: 'select_download_type',
    support_title: documentInfo.titleEN_t[0],
    support_type: documentInfo.supportTypeEN_ss[0],
    support_sub_category: 'N/A',
    file_type:
      documentInfo.urlKeyword_s.indexOf(
        '.',
        documentInfo.urlKeyword_s.lastIndexOf('/') + 1
      ) == -1
        ? 'url'
        : documentInfo.urlKeyword_s.split(/[#?]/)[0].split('.').pop().trim() ==
          'com'
        ? 'url'
        : documentInfo.urlKeyword_s.split(/[#?]/)[0].split('.').pop().trim(),
    content_owner: sessionData.manufacturingDivision
  });
};

export {
  initialize,
  addToCartDataLayer,
  shareConfigurationDataLayer,
  partSearchDataLayer,
  copyToClipboardDataLayer,
  saveConfigurationDataLayer,
  loadConfigurationDataLayer,
  deleteConfigurationDataLayer,
  cancelConfigurationDataLayer,
  whereToBuyDataLayer,
  requestQuoteDataLayer,
  viewSummarySheetDataLayer,
  supportDocumentDataLayer
};
